export default [
  '$window', 'addFormService', 'config', 'logger', 'addFormLayoutService', 'navigationService',
  function ($window, addFormService, config, logger, addFormLayoutService, navigationService) {
  const URL = config.get('addformConfig.soprApi') || 'https://sopr-api.cian.ru/telemetry/';

  const isTelemetryReportingEnabled = () => {
    return config.get('addformConfig.isTelemetryEnabled');
  };

  const getCookieByName = (name) => {
    const cookie = document.cookie.match(new RegExp(name + '=([^;]+)'));

    return cookie && cookie.length && cookie[1];
  };

  const getFormType = () => {
    return addFormLayoutService.isShortLayout ? 'short' : 'full';
  };

  const getFormId = () => {
    return $window.formId;
  };

  const getUserId = () => {
    return getCookieByName('cian_ruid') || getCookieByName('_CIAN_GK') || '';
  };

  const getSessionId = () => {
    return getCookieByName('_CIAN_GK');
  };

  const getCurrentDate = () => {
    return Number(new Date());
  };

  const getAllInvalidFieldsNames = () => {
    const form = addFormService.form;

    const errorKeys = Object.keys(form.$error);

    const fieldNames = [];

    errorKeys.forEach((key) => {
      form.$error[key].forEach((field) => {
        if (field && field.$name) {
          fieldNames.push(field.$name);
        }
      });
    });

    return fieldNames;
  };

  const getFieldInstanceFromForm = (fieldName) => {
    const form = addFormService.form;

    return form[fieldName];
  };

  const getFieldValue = (fieldName) => {
    const field = getFieldInstanceFromForm(fieldName);

    return field.$modelValue;
  };

  const getFieldErrors = (fieldName) => {
    const field = getFieldInstanceFromForm(fieldName);

    return Object.keys(field.$error);
  };

  const getFieldTouchState = (fieldName) => {
    const field = getFieldInstanceFromForm(fieldName);

    return field.$touched;
  };

  const getFieldDirtyState = (fieldName) => {
    const field = getFieldInstanceFromForm(fieldName);

    return field.$dirty;
  };

  const getFieldErrorsDump = () => {
    const invalidFieldsNames = getAllInvalidFieldsNames();

    const dump = invalidFieldsNames.reduce((map, fieldName) => {
      map[fieldName.replace('.', '_')] = {
        value: getFieldValue(fieldName),
        errors: getFieldErrors(fieldName),
        touched: getFieldTouchState(fieldName),
        dirty: getFieldDirtyState(fieldName),
      };

      return map;
    }, {});

    return dump;
  };

  const sendMessageHandler = (xhr) => {
    if (xhr.readyState === 4) {
      if (xhr.status !== 200) {
        logger.error(xhr.response, {
          description: 'Fail to send publish telemetry event.',
          degradation: 'Not needed. No user experience affected.',
        });
      }
    }
  };

  const generateTelemetryMessage = () => {
    return {
      client: {
        sessionId: getSessionId(),
        userId: getUserId(),
        formId: getFormId(),
      },
      navigationItems: navigationService.getNavigationItemsForTelemetry(),
      publishErrors: {
        dump: getFieldErrorsDump(),
        formType: getFormType(),
        date: getCurrentDate(),
      },
    };
  };

  const sendTelemetryMessage = () => {
    if (!isTelemetryReportingEnabled()) {
      return;
    }

    try {
      const xhr = new XMLHttpRequest();

      const data = JSON.stringify(generateTelemetryMessage());

      xhr.open('POST', URL, true);
      xhr.onreadystatechange = () => sendMessageHandler(xhr);
      xhr.send(data);
    } catch (e) {
      logger.error(e, {
        description: 'Fail to send publish telemetry event.',
        degradation: 'Not needed. No user experience affected.',
      });
    }
  };

  window.sendTelemetryMessage = sendTelemetryMessage;

  const svc = {
    sendTelemetryMessage,
  };

  return svc;
}];
